import { is } from '@common/is/is'

/**
 * Ez az alap hiba, ami browsertől független.
 * Normalizálás előtt akár üres object is lehet.
 * Minden property opcionális, nem lehet tudni mit kapunk, ezek lesznek normalizálva.
 */
interface IBaseError {
  readonly stack?:        string
  readonly columnNumber?: number
  readonly lineNumber?:   number
  readonly lineno?:       number
  readonly colno?:        number
  readonly message?:      string
}

/** A 4 fő property biztosan benne lesz a kimenetben. */
interface INormalizedError {
  readonly stack:        string[]
  readonly columnNumber: number
  readonly lineNumber:   number
  readonly message:      string
}

/**
 * Cross-browser error normalizálás.
 * @param data - Az adat, amit normalizálni fogunk.
 */
export default function getNormalizedError (data: unknown): INormalizedError {
  const baseError = (
    (
      (
        is.object(data) &&
        is.property(data, 'error') &&
        is.object(data.error)
      )
        ? data.error
        : data
    ) ?? {}
  ) as IBaseError

  const stack        = baseError.stack ? baseError.stack.split('\n') : []
  const columnNumber = is.number(baseError.columnNumber) ? baseError.columnNumber : (baseError.colno ?? -1)
  const lineNumber   = is.number(baseError.lineNumber) ? baseError.lineNumber : (baseError.lineno ?? -1)

  let message = '?'

  try {
    message = baseError.message ??
      (
        is.property(data, 'message') && is.string(data.message)
          ? data.message
          // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
          : (data as any).toString()
      )
  }
  catch {
    /* noop */
  }

  return {
    stack,
    columnNumber,
    lineNumber,
    message
  }
}
